// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { radioClasses } from '@mui/material/Radio';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { rem } from '../../tokens/conversions';
import { borderRadius } from '../../tokens/spacing';
import { radioColors } from './radioColors';
export var Radio = function(mode) {
    var c = radioColors(mode);
    var _obj, _obj1, _obj2;
    var override = {
        MuiRadio: {
            styleOverrides: {
                root: (_obj1 = {
                    color: c.default.border,
                    padding: rem(0),
                    borderRadius: rem(borderRadius.small),
                    marginRight: rem(0),
                    width: rem(24),
                    height: rem(24),
                    border: "".concat(rem(1), " solid transparent"),
                    boxSizing: 'border-box'
                }, _define_property(_obj1, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(24)
                }), _define_property(_obj1, '&:hover', {
                    color: c.hover.border
                }), _define_property(_obj1, '&:focus-within', {
                    borderColor: c.focus.border,
                    borderRadius: rem(50)
                }), _define_property(_obj1, "&.".concat(radioClasses.disabled), {
                    color: c.disabled.border
                }), _define_property(_obj1, "&.".concat(radioClasses.checked), (_obj = {
                    color: c.checked.knob
                }, _define_property(_obj, "& .".concat(svgIconClasses.root, ":first-of-type"), {
                    color: c.checked.border
                }), _define_property(_obj, '&:hover', _define_property({
                    color: c.checked.knob
                }, "& .".concat(svgIconClasses.root, ":first-of-type"), {
                    color: c.hover.border
                })), _define_property(_obj, "&.".concat(radioClasses.disabled), _define_property({
                    color: c.disabled.knob
                }, "& .".concat(svgIconClasses.root, ":first-of-type"), {
                    color: c.disabled.border
                })), _obj)), _define_property(_obj1, "&.".concat(radioClasses.sizeSmall), _define_property({
                    width: rem(16),
                    height: rem(16)
                }, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(16)
                })), _obj1)
            },
            variants: [
                {
                    props: {
                        size: 'large'
                    },
                    style: (_obj2 = {
                        width: rem(32),
                        height: rem(32)
                    }, _define_property(_obj2, "& .".concat(svgIconClasses.root), {
                        fontSize: rem(32)
                    }), _define_property(_obj2, '&:focus-within', {
                        borderWidth: rem(2)
                    }), _obj2)
                }
            ],
            defaultProps: {
                disableRipple: true,
                color: 'primary'
            }
        }
    };
    return override;
};

//# sourceMappingURL=Radio.js.map